import React from 'react';
import {injectIntl} from 'react-intl';
import DistancePin from "@Components/DistancePin";
import Icon from "@Components/Icon";

function BranchListItem({intl, branchData, distance, appConfigs, branchDataLinkTitle, modalDataSetter}) {

  function openModal(e) {
    e.preventDefault();
    modalDataSetter(branchDataLinkTitle, branchData)
  }
    const specs = [];
    let addSpecsData = (names) => {
        for (let index = 0; index < names.length; index++) {
            let specsName = names[index].toLowerCase();
            if(!specs.includes(specsName)) {
                specs.push(specsName)
            }
        }
    }

    //Adding main office phone and specialism if they exist
    if(branchData.main_office_spec) {
        addSpecsData(branchData.main_office_spec);
    }

    //Adding related offices phones and specialisms if they exist
    if(branchData.related_office_spec_names) {
        addSpecsData(branchData.related_office_spec_names);
    }

    const Specs = ({specs}) => {
        if (typeof specs != "undefined") {
            return (
              <>
                {
                  blueCardItem ? 

                  <div className="cards__meta-item mb-m">
                    <Icon icon="label" className="icon icon--inline text-white mr-s"/>
                    <div className="w-10/12 text-white">
                      {specs.map((specialism, i, arr) =>
                        <span key={specialism}> {specialism}{i != (arr.length-1) ? ',' : ''} </span>
                      )}
                    </div>
                  </div>
                  :
                  <div className="cards__meta-item mb-l">
                  <Icon icon="label" className="icon icon--inline text-brand-secondary-tint-60 mr-s"/>
                  <div className="w-10/12">
                  {specs.map((specialism, i, arr) =>
                      <span key={specialism}> {specialism}{i != (arr.length-1) ? ',' : ''} </span>
                    )}
                  </div>
                </div>
                }
              </>
            )
        } else {
            return null
        }
    };

    // Set bg dark blue to randstad items.
    let blueCardItem = (branchData.field_brand && branchData.field_brand[0] === 'rss') || (branchData.field_brand_main && branchData.field_brand_main[0] === 'rss')

    return (
      <>
        {
            blueCardItem ?
                
          <li className="cards__item bg-brand-secondary">
            <div className="text-white">{intl.formatMessage({id: "Branches.BlueCard.TopTitle"})}</div>
            <h3 className="cards__title mb-s">
                <a className="cards__link text-white" href={branchData.url}>{branchData.title}</a>
            </h3>
            <div className="text-brand-secondary-tint-60 mb-s text-white">
              <div>{branchData.address_line1}</div>
              <div>{ (branchData.postal_code || '') + ' ' + (branchData.locality || '')}</div>
            </div>
            <Specs specs={specs} />
            <div className="cards__footer flex-col">
            { branchData.main_office_phone &&
              (
              <div>
                <a className="cards__meta-item" href="#" onClick={openModal} data-dialog-type="modal" data-rs-modal-trigger={branchDataLinkTitle}>
                  <Icon icon="phone" className="icon icon--inline text-white mr-s"/>
                  <span className="w-10/12 mb-xs text-white">{intl.formatMessage({id: "Branches.ModalLink"})}</span>
                </a>
              </div>
              )
            }
              <div>
                <a className="cards__meta-item" href={`http://www.google.com/maps/place/${branchData.lat},${branchData.lng}`} target="_blank" rel="noopener noreferrer">
                  <Icon icon="marker" className="icon icon--inline text-white mr-s"/>
                  <span className="w-10/12 mb-xs text-white">{intl.formatMessage({id: "Branches.Directions"})}</span>
                </a>
              </div>
            </div>
          </li>
          :
          <li className="cards__item">
            <h3 className="cards__title mb-s">
                <a className="cards__link" href={branchData.url}>{branchData.title}</a>
            </h3>
            <div className="text-brand-secondary-tint-60 mb-s">
              <div>{branchData.address_line1}</div>
              <div>{ (branchData.postal_code || '') + ' ' + (branchData.locality || '')}</div>
            </div>
            <Specs specs={specs} />
            <div className="cards__footer flex-col">

            { branchData.main_office_phone &&
            (
              <div>
                <a className="cards__meta-item" href="#" onClick={openModal} data-dialog-type="modal" data-rs-modal-trigger={branchDataLinkTitle}>
                  <Icon icon="phone" className="icon icon--inline icon--informative mr-s"/>
                  <span className="w-10/12 mb-xs">{intl.formatMessage({id: "Branches.ModalLink"})}</span>
                </a>
              </div>
              )
            }
              <div>
              <a className="cards__meta-item" href={`http://www.google.com/maps/place/${branchData.lat},${branchData.lng}`} target="_blank" rel="noopener noreferrer">
                <Icon icon="marker" className="icon icon--inline icon--informative mr-s"/>
                <span className="w-10/12 mb-xs">{intl.formatMessage({id: "Branches.Directions"})}</span>
              </a>
              </div>
            </div>
          </li>
        }
      </>
    );
}

export default injectIntl(BranchListItem);
